function reshapePromotionsResponse(promotions) {
  return promotions.map(promo => {
    return {
      ...promo.audiobook,
      currentProduct: promo.product,
    };
  });
}

export const graphQLHelpers = {
  reshapePromotionsResponse,
};
